"use strict";
/* eslint @typescript-eslint/explicit-module-boundary-types: 0 */
/* eslint @typescript-eslint/no-explicit-any: 0 */
Object.defineProperty(exports, "__esModule", { value: true });
let eventHandlerInited = false;
function initCollapsibles(element) {
    if (eventHandlerInited) {
        return;
    }
    eventHandlerInited = true;
    element.addEventListener('click', (event) => {
        const target = event.target;
        if (target && Array.from(target.classList).includes('collapsible__open')) {
            target.parentElement.classList.add('collapsible_opened');
        }
        if (target && Array.from(target.classList).includes('collapsible__close')) {
            target.parentElement.classList.remove('collapsible_opened');
        }
    });
}
exports.default = initCollapsibles;
//# sourceMappingURL=collapsible.js.map